<template>
  <div class="caller-chat">
    <b-button pill variant="info" @click="openChatSidebar">
      <b-icon-chat-right-text scale="1" />
      <b-badge v-if="newMessageBadge" class="ml-2" size="sm" variant="danger">New</b-badge>
    </b-button>
    <b-sidebar
      v-model="showChatSidebar"
      width="100vw"
      right
      no-header
      sidebar-class="caller-chat__sidebar"
    >
      <QuickChat
        :magicToken="magicToken"
        @close="closeChatSidebar"
      />
    </b-sidebar>
  </div>
</template>

<script>
/* eslint-disable */
import { EventBus } from "../events/eventBus";
import QuickChat from "./QuickChat"

export default {
  name: "CallerChat",
  components: {
    QuickChat,
  },
  props: { magicToken: Object },
  data() {
    return {
      showChatSidebar: false,
      newMessageBadge: false,
    };
  },
  created() {
    EventBus.$on("chat.new-msg-badge", () => {
      if (!this.showChatSidebar) {
        this.newMessageBadge = true;
      }
    });
  },
  methods: {
    closeChatSidebar() {
      this.showChatSidebar = false;
    },
    openChatSidebar() {
      this.showChatSidebar = true;
      this.newMessageBadge = false;
    }
  },
  beforeDestroy() {
    EventBus.$off("chat.new-msg-badge")
  }
}
</script>

<style lang="scss" scoped>
.caller-chat {}
</style>